

































































































































































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ThDropdownVue from "../components/ThDropdown.vue";
import LetterTabVue from "../components/LetterTab.vue";
import AssignAccountVue from "../components/AccountBookList/AssignAccount.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import ViewAccountBookVue from "@/components/AccountBookList/ViewAccountBook.vue";
import AccountImportVue from "@/components/AccountBookList/AccountImport.vue";
import version from "@/version";
import ThDatePickerVue from "../components/ThDatePicker.vue";

@Component({
	...mapGetters(["account"]),
	components: {
		"th-date": ThDatePickerVue,
		"th-dropdown": ThDropdownVue,
		"letter-tab": LetterTabVue,
		"assign-account": AssignAccountVue,
		"view-book": ViewAccountBookVue,
		"user-tree": AllUserTreeVue,
		"account-import": AccountImportVue
	},
})
export default class AccountBookList extends Vue {
	// 导入
	isImport: boolean = false
	successImport() {
		this.isImport = false
		this.fetchData()
	}
	closeImport() {
		this.isImport = false
	}
	// 日期筛选
    dateValue:string = ""
    chooseDate(date:string){
        this.dateValue = date
        this.fetchData()
    }
	// 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
		if (this.activeName === "回收站") {
			this.fetchData();
		} else {
			this.getFetch();
		}
    }
	isJzs = process.env.VUE_APP_TITLE === "jzs";
	activeName: string = "回收站";
	changeLetter() {
		this.currentPage = 1;
		if (this.activeName === "回收站") {
			this.fetchData();
		} else {
			this.getFetch();
		}
	}
	restore(data: any) {
		this.$msgbox({
			message: "亲，确定要恢复账套吗？",
			title: "温馨提示",
			confirmButtonText: "确定",
			showCancelButton: true,
		}).then((action: any) => {
			if (action == "confirm") {
				Vue.axios
					.post(
						`accountbooks/restore?id=${data.id}
                `,
						{ type: "nothing" }
					)
					.then(() => {
						this.getFetch();
					});
			}
		});
	}
	changeType() {
		this.currentPage = 1;
		if (this.activeName === "回收站") {
			this.getFetch();
			this.activeName = "客户列表";
		} else {
			this.fetchData();
			this.activeName = "回收站";
		}
	}
	clientList: AccountBookList.AccountBook[] = [];
	taxpayerList: DataTable.DropItem[] = [
		{ text: "全部", id: "" },
		{ text: "小规模纳税人", id: "小规模纳税人" },
		{ text: "一般纳税人", id: "一般纳税人" },
	];
	chargeList: DataTable.DropItem[] = [
		{
			text: "全部",
			id: 0,
		},
		{
			text: "未到期",
			id: 1,
		},
		{
			text: "正欠费",
			id: 2,
		},
		{
			text: "预警期",
			id: 3,
		},
	];
	accountList: DataTable.DropItem[] = [
		{
			text: "全部",
			id: 0,
		},
		{
			text: "已完成",
			id: 3,
		},
		{
			text: "未记账",
			id: 1,
		},
		{
			text: "进行中",
			id: 2,
		},
	];
	taxList: DataTable.DropItem[] = [
		{
			text: "全部",
			id: 0,
		},
		{
			text: "已报税",
			id: 1,
		},
		{
			text: "未报税",
			id: 2,
		},
		{
			text: "进行中",
			id: 3,
		},
	];
	// 下拉
	accountStatus: DataTable.DropItem = this.accountList[0];
	chargeStatus: DataTable.DropItem = this.chargeList[0];
	taxStatus: DataTable.DropItem = this.taxList[0];
	taxpayerStatus: DataTable.DropItem = this.taxpayerList[0];

	// 分页
	pageSize: number = 14;
	currentPage: number = 1;
	totalElements: number = 0;

	searchKey: string = "";

	mounted() {
		this.$store.state.accountBook = {
			id: null,
			bookName: ""
		};
		if(localStorage.getItem("isCodeSort")) {
			this.isCodeSort = localStorage.getItem("isCodeSort") === "1"?true:false
		}
		if (this.$route.query.taxStatus) {
			let taxStatus = Number(this.$route.query.taxStatus);
			this.taxStatus = <DataTable.DropItem>this.getStatus(2, taxStatus);
		}
		if (this.$route.query.chargeStatus) {
			let chargeStatus = Number(this.$route.query.chargeStatus);
			this.chargeStatus = <DataTable.DropItem>(
				this.getStatus(0, chargeStatus)
			);
		}
		if (this.$route.query.accountStatus) {
			let accountStatus = Number(this.$route.query.accountStatus);
			this.accountStatus = <DataTable.DropItem>(
				this.getStatus(1, accountStatus)
			);
		}
		if (this.$route.query.accounterNo) {
			this.accounterNo = this.$route.query.accounterNo;
		}
		if (this.$route.query.scope) {
			if (this.$route.query.scope === "") this.isScope = true;
			else this.isScope = false;
		}
		if (this.$route.query.name) {
			this.accounterName = this.$route.query.name;
		}
		// this.$store.dispatch("initAccounBook");
		this.fetchData();
	}
	// 获取数据
	getFetch() {
		Vue.axios
			.post(
				`accountbooks/del/listall?page=${this.currentPage - 1}&size=${
					this.pageSize
				}`,
				{
					// accountStatus: this.accountStatus.id.toString(),
					accounterNo: this.accounterNo,
					// addtax: this.taxpayerStatus.id.toString(),
					// chargeStatus: this.chargeStatus.id.toString(),
					query: this.$store.state.searchKey.trim(),
					scope: this.isScope ? "" : "all",
					// searchKey: this.searchKey.trim(),
					// taxStatus: this.taxStatus.id.toString(),
				}
			)
			.then((res) => {
				res.data.content.forEach((v: any) => {
					v.checked = false;
					this.checkedArr.forEach((item) => {
						if (item.id === v.id) v.checked = true;
					});
				});
				this.clientList = res.data.content;
				this.totalElements = res.data.totalElements;
				this.$forceUpdate();
			});
	}

	accounterNo: string = this.$store.state.account.no;
	fetchData() {
		this.checkedAll = false;
		Vue.axios
			.post(
				`accountbooks/listall?page=${this.currentPage - 1}&size=${
					this.pageSize
				}`,
				{
					accountStatus: this.accountStatus.id.toString(),
					accounterNo: this.accounterNo,
					addtax: this.taxpayerStatus.id.toString(),
					chargeStatus: this.chargeStatus.id.toString(),
					query: this.$store.state.searchKey.trim(),
					scope: this.isScope ? "" : "all",
					searchKey: this.searchKey.trim(),
					taxStatus: this.taxStatus.id.toString(),
					currentPeriod: this.dateValue,
					isSortByCode: this.isCodeSort
				}
			)
			.then((res) => {
				res.data.content.forEach((v: any) => {
					v.checked = false;
					this.checkedArr.forEach((item) => {
						if (item.id === v.id) v.checked = true;
					});
				});
				this.clientList = res.data.content;
				this.totalElements = res.data.totalElements;
				this.$forceUpdate();
			});
	}
	getStatus(type: number, code: number) {
		if (type === 0) {
			for (let i = 0; i < this.chargeList.length; i++) {
				if (this.chargeList[i].id === code) return this.chargeList[i];
			}
		} else if (type === 1) {
			for (let i = 0; i < this.accountList.length; i++) {
				if (this.accountList[i].id === code) return this.accountList[i];
			}
		} else {
			for (let i = 0; i < this.taxList.length; i++) {
				if (this.taxList[i].id === code) return this.taxList[i];
			}
		}
	}

	handleCurrentChange(val: number) {
		this.currentPage = val;
		if (this.activeName === "回收站") {
			this.fetchData();
		} else {
			this.getFetch();
		}
	}

	inAccountBook(data: AccountBookList.AccountBook) {
		Vue.axios.post(`accountbooks/` + data.id).then((res) => {
			this.$store.dispatch("changeAccounBook", res.data);
			this.$utils.setTaxType(res.data);
			this.$utils.getRemarks();
			window.open("/voucherlist", "_blank");
		});
	}

	/**
	 * 客户列表checkbox选中的事件及逻辑处理
	 */
	checkedAll: boolean = false;
	checkedArr: AccountBookList.AccountBook[] = [];

	/**
	 *  全选
	 */
	// 判断是否存在与已选中的数组中
	isInCheck(book: AccountBookList.AccountBook) {
		let hasThis = false;
		for (let j = 0; j < this.checkedArr.length; j++) {
			if (this.checkedArr[j].id === book.id) {
				return { has: true, index: j };
			}
		}
		return false;
	}
	// 点击全选按钮
	fnCheckedAll(val: boolean) {
		if (val) {
			for (let i = 0; i < this.clientList.length; i++) {
				let curCli = this.clientList[i];
				if (!this.isInCheck(curCli)) this.checkedArr.push(curCli);
				curCli.checked = true;
			}
		} else {
			for (let i = 0; i < this.clientList.length; i++) {
				let curCli = this.clientList[i];
				let current = this.isInCheck(curCli);
				if (current) this.checkedArr.splice(current.index, 1);
				curCli.checked = false;
			}
		}
	}
	// 监听列表中对象，若全为check则全选为真
	@Watch("clientList", { deep: true })
	dataChange(val: AccountBookList.AccountBook[]) {
		let flag = true;
		for (let i = 0; i < val.length; i++) {
			if (!val[i].checked) {
				flag = false;
				break;
			}
		}
		this.checkedAll = flag;
	}

	// 点击td中checkbox
	checkChange(val: boolean, data: AccountBookList.AccountBook, i: number) {
		let cb = this.isInCheck(data);
		if (val) {
			data.checked = true;
			this.$set(this.clientList, i, data);
			if (!cb) this.checkedArr.push(data);
		} else {
			data.checked = false;
			this.$set(this.clientList, i, data);
			if (cb) this.checkedArr.splice(cb.index, 1);
		}
		this.$forceUpdate();
	}

	// 点击指派
	clickAssign() {
		if (this.checkedArr.length === 0) {
			this.$message.warning("请选择指派客户");
		} else {
			this.assignAccount = true;
		}
	}

	// 指派会计 模态框
	assignAccount: boolean = false;
	closeAssign() {
		this.assignAccount = false;
		this.$forceUpdate();
	}
	assignSuccess() {
		this.assignAccount = false;
		for (let i = 0; i < this.clientList.length; i++) {
			let curCli = this.clientList[i];
			let current = this.isInCheck(curCli);
			curCli.checked = false;
		}
		this.checkedArr = [];
		this.currentPage = 1;
		if (this.activeName === "回收站") this.fetchData();
		else this.getFetch();
	}

	// 修改客户
	showInfo: boolean = false;
	bookData: AccountBookList.AccountBook | null = null;
	accountModify(data: AccountBookList.AccountBook) {
		Vue.axios.get(`accountbooks/${data.id}`).then((res) => {
			this.bookData = res.data;
			this.showInfo = true;
		});
	}
	// 模态框 close
	closeInfo() {
		this.showInfo = false;
	}
	infoSuccess() {
		this.showInfo = false;
		this.fetchData();
	}
	accounterName: string = "所属人姓名";
	// 打开tree
	isTree: boolean = false;
	openTree() {
		this.isTree = !this.isTree;
	}
	// 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
	tmp: UserTree | null = null;
	treeExpand(data: UserTree) {
		this.tmp = data;
	}
	// 点击tree中的名字(node)
	isScope: boolean = false;
	handleNodeClick(data: Account) {
		this.isScope = true;
		if (data.name) this.accounterName = data.name;
		this.currentPage = 1;
		this.$store.dispatch("clearSearchKey");
		this.accounterNo = data.no;
		if (this.activeName === "回收站") this.fetchData();
		else this.getFetch();
		this.isTree = false;
	}
	// 关闭tree
	closeTree() {
		this.isTree = false;
	}
	// 删除帐套
	delAccountBook(data: AccountBookList.AccountBook) {
		let name = "亲，确定要删除吗？";
		if (this.activeName != "回收站") {
			name = "亲，确定要彻底删除吗？(此操作无法撤回请谨慎操作 !!!)";
		}
		this.$msgbox({
			message: name,
			title: "温馨提示",
			confirmButtonText: "确定",
			showCancelButton: true,
		}).then((action: any) => {
			if (action == "confirm") {
				if (this.activeName === "回收站") {
					Vue.axios
						.post(`accountbooks/` + data.id + `/delete`, {
							id: 123,
						})
						.then(() => {
							this.fetchData();
						});
				} else {
					Vue.axios
						.post(`accountbooks/` + data.id + `/del`, {
							id: 123,
						})
						.then(() => {
							this.getFetch();
						});
				}
			}
		});
	}

	// 批量结账
	async multiClose() {
		if (this.checkedArr.length > 0) {
			const action = await this.$confirm(
				"亲，确定要批量结账吗？",
				"温馨提示"
			);
			if (action === "confirm") {
				let ids: number[] = [];
				this.checkedArr.forEach((e) => {
					ids.push(e.id);
				});
				// ids.join(",")
				const res = await Vue.axios.post(
					`close/accountbook/multi?ids=${ids.join(",")}`,
					{ nothing: "" }
				);
				this.$notify({
					title: "温馨提示",
					message: res.data.message,
				});
				this.checkedArr = [];
				this.fetchData();
			}
		} else {
			this.$message("请勾选要结账的账套");
		}
	}

	// 导出客户列表
	exportList() {
		const url = `${Vue.axios.defaults.baseURL}export/account/books?query=${this.$store.state.searchKey}&token=${this.$store.state.account.token}&version=${version}&searchKey=${this.searchKey}&addTax=${this.taxpayerStatus.id.toString()}&accountStatus=${this.accountStatus.id.toString()}&chargeStatus=${this.chargeStatus.id.toString()}&taxStatus=${this.taxStatus.id.toString()}&accounterNo=${this.accounterNo}&scope=${this.isScope ? "" : "all"}`;
		this.$store.dispatch("toggleDownload", true);
		this.$utils.sendToElectron("download", url);
	}

	isCodeSort = false;
	changeCode() {
		localStorage.setItem(
                "isCodeSort",
                this.isCodeSort?"1":"0"
            );
		this.fetchData()	
	}
}
